import { useTranslation } from 'react-i18next';

import { useResetSteps } from '../../../../core/hooks/useResetSteps';

import { StepName } from '~/core/enums';
import WarningModal from '~molecules/WarningModal';

type StoreChangeModalProps = {
  newZipCode?: string;
  isVisible: boolean;
  handleClose: () => void;
  handleChange: () => unknown;
};

const StoreChangeModal = ({
  newZipCode,
  isVisible,
  handleClose,
  handleChange,
}: StoreChangeModalProps) => {
  const { t } = useTranslation();
  const { resetEasyEstimatorState, restoreDataWithoutAutoNavigation } =
    useResetSteps();

  const modalTitle = newZipCode
    ? `${t(
        'SCROLLABLE_AREA.ADDRESS_INFORMATION.CONFIRMATION_MODAL.ZIPCODE_TITLE'
      )} ${newZipCode}?`
    : t('SCROLLABLE_AREA.ADDRESS_INFORMATION.CONFIRMATION_MODAL.STORE_TITLE');
  const modalDescription = t(
    'SCROLLABLE_AREA.ADDRESS_INFORMATION.CONFIRMATION_MODAL.DESCRIPTION'
  );
  const buttons = {
    cancel: t(
      'SCROLLABLE_AREA.ADDRESS_INFORMATION.CONFIRMATION_MODAL.BUTTON_CANCEL'
    ),
    confirm: t(
      'SCROLLABLE_AREA.ADDRESS_INFORMATION.CONFIRMATION_MODAL.BUTTON_CONFIRM'
    ),
  };

  return (
    <WarningModal
      title={modalTitle}
      description={modalDescription}
      buttons={buttons}
      isVisible={isVisible}
      onCancel={handleClose}
      onConfirm={() => {
        resetEasyEstimatorState(StepName.store, {
          allowStoreReset: true,
          allowZipcodeReset: Boolean(newZipCode),
        });
        restoreDataWithoutAutoNavigation(handleChange);
      }}
    />
  );
};

export default StoreChangeModal;
